import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

export const PURE_SOULS_URL = "https://puresouls.com.au";

export const SITE_URL = "https://petwatercremationaustralia.com";
export const SITE_NAME = "Pet Water Cremation Australia";

// Site imagery (bespoke, optimized, served from /public/images).
export const IMG = {
  // Atmospheric / background imagery
  heroFog: "/images/lake-sunrise.jpg",
  heroClouds: "/images/eucalyptus-forest.jpg",
  texSage: "/images/eucalyptus-water.jpg",
  texWater: "/images/water-texture.jpg",
  leaf: "/images/eucalyptus-water.jpg",
  // Clear foreground subjects
  dogGrass: "/images/dog-coast.jpg",
  dogFluffy: "/images/cat-lake.jpg",
  // Explicit semantic aliases
  catLake: "/images/cat-lake.jpg",
  catWindow: "/images/cat-lake.jpg",
  handPaw: "/images/hand-paw.jpg",
  dogCoast: "/images/dog-coast.jpg",
  dogSunset: "/images/dog-sunset.jpg",
  lakeSunrise: "/images/lake-sunrise.jpg",
  eucalyptusForest: "/images/eucalyptus-forest.jpg",
  eucalyptusWater: "/images/eucalyptus-water.jpg",
  waterTexture: "/images/water-texture.jpg",
  australiaWater: "/images/australia-water.jpg",
};

// Signature brand image (Australia rendered in flowing water) for social sharing.
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/australia-water.jpg`;

export const TAGLINES = [
  "Gentle Care Inspired By Nature",
  "Understanding Modern Pet Aftercare",
  "A More Sustainable Farewell",
  "Compassionate Education For Pet Families",
  "Exploring The Future Of Pet Cremation",
  "Gentle Water Based Pet Aftercare In Australia",
];
